<button type="button"
        mat-icon-button
        (click)="delete()"
        [disabled]="params?.api?.rowEdit?.isDeleteDisabled">
  <mat-icon class="material-icons">delete</mat-icon>
</button>
